import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation('home');

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20fashion%20lifestyle%20scene%20in%20sunlit%20industrial%20loft%20with%20exposed%20brick%20walls%20and%20large%20windows%20stylish%20streetwear%20models%20in%20casual%20poses%20natural%20golden%20hour%20light%20streaming%20through%20editorial%20fashion%20photography%20warm%20earthy%20tones%20premium%20catalog%20aesthetic&width=1600&height=900&seq=hero-cssbuy-revamp-01&orientation=landscape"
          alt="CSSBuy Spreadsheet fashion products"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left pt-20 lg:pt-0">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight tracking-tight">
              {t('hero_h1_line1')}
              <br />
              <span className="italic text-primary-300">
                {t('hero_h1_line2')}
              </span>
            </h1>
            <p className="mt-5 text-sm md:text-base text-background-50/85 max-w-lg mx-auto lg:mx-0 leading-relaxed">
              {t('hero_subheadline')}
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                {t('hero_cta_primary')}
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-background-50/40 text-background-50 rounded-full text-sm font-semibold hover:bg-background-50/15 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                {t('hero_cta_secondary')}
              </a>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-4 justify-center lg:justify-start">
              <span className="flex items-center gap-1.5 text-xs text-background-50/75">
                <i className="ri-check-line text-accent-400"></i>
                {t('hero_trust_updated')}
              </span>
              <span className="flex items-center gap-1.5 text-xs text-background-50/75">
                <i className="ri-check-line text-accent-400"></i>
                {t('hero_trust_verified')}
              </span>
              <span className="flex items-center gap-1.5 text-xs text-background-50/75">
                <i className="ri-check-line text-accent-400"></i>
                {t('hero_trust_guide')}
              </span>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:block">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20premium%20fashion%20items%20on%20textured%20concrete%20surface%20with%20dried%20flowers%20and%20magazine%20editorial%20still%20life%20photography%20soft%20window%20light%20from%20left%20warm%20neutral%20and%20dusty%20rose%20palette%20sophisticated%20minimal%20composition&width=800&height=600&seq=hero-side-revamp-01&orientation=landscape"
                alt="CSSBuy curated products"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-6 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}